import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';
import { AuditsState } from './types/audits.types';

export const auditsGetters: GetterTree<AuditsState, RootState> = {

};
